<template>
  <!-- More two variable  -->
  <div class="header-order">
    <div class="first-column">
      <span>
        {{ endDate }}
      </span>
      <span
        v-if="daoSumResult !== '0'"
        class="link"
        @click="goToVotePage"
      >
        {{ $t("daoTokens.survey.protocol") }}
      </span>
    </div>
    <span>
      {{ daoRequest.description }}
    </span>
    <Apexchart
      height="160px"
      width="290px"
      type="donut"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import _ from "lodash";
import BigNumber from "bignumber.js";
import moment from "moment";

export default {
  props: {
    daoRequest: {
      type: Object,
      default: () => {},
      required: true
    },

    projectId: {
      type: Number,
      default: 0
    }
  },

  computed: {
    endDate() {
      const date = moment(this.daoRequest.endAt);
      return date.isSame(moment(), "day")
        ? `${this.$t("daoTokens.survey.today")} ${date.format("hh:mm")}`
        : date.format("DD.MM.YYYY");
    },

    daoSumResult() {
      return _.reduce(this.daoRequest?.result, (acc, el) =>
        BigNumber(el?.amount ?? 0).plus(acc).toFixed(0), "0");
    },

    series() {
      if (this.daoSumResult === "0") {
        return [1];
      }
      return _.map(this.daoRequest?.result, el =>
        BigNumber(el.amount).multipliedBy(100).dividedBy(this.daoSumResult).toNumber());
    },
    options() {
      const ret = {
        labels: this.daoSumResult !== "0" ? _.map(this.daoRequest?.result, el => el.name) : ["Empty vote"],
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: this.daoSumResult !== "0"
        },
        legend: {
          fontSize: "11px",
          fontFamily: "Suisse Intl",
          labels: {
            colors: [this.isLightTheme ? "#080808" : "#FFFFFF"]
          },
          markers: {
            width: 12,
            height: 8
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " - ",
              opts.w.globals.series[opts.seriesIndex],
              "%"
            ];
          }
        }
      };
      if (this.daoSumResult === "0") {
        ret["colors"] = ["#b3b3b3"];
        ret.legend.formatter = undefined;
      }
      return ret;
    },
    isLightTheme() {
      return this.$store.getters.isLightTheme;
    }
  },
  methods: {
    goToVotePage() {
      if (this.daoSumResult !== "0") {
        this.$router.push({ name: "voiting protocol", params: { id: this.daoRequest.id + `&project=${this.projectId}` } });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-order {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr;
  padding: 20px 0;
  border-bottom: 1px dashed var(--border-color);
}
.first-column {
  display: flex;
  flex-direction: column;

  .link {
    cursor: pointer;
    color: #2ABA7C;
  }
}
</style>
